module.exports = __webpack_public_path__ + "static/media/niceshel.a4779549.png";